module.exports = __webpack_public_path__ + "img/mollie-integration.32a34c4e.png";